"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledList = exports.StyledDialog = void 0;
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
const generic_1 = require("../../../generic");
exports.StyledDialog = (0, styled_components_1.default)(generic_1.ActionDialog) `
  .MuiDialog-paper {
    min-height: 30vh;
    max-height: 70vh;
  }

  .terminal-nodes-autocomplete {
    width: 100%;
  }

 .MuiDialogTitle-root {
    font-size: 1.5rem;
  }

  .product-count {
    font-weight: 400;
  }
`;
exports.StyledList = (0, styled_components_1.default)(material_1.List) `
  flex: 1;
  overflow: hidden;
  padding: 0;
  list-style-type: none;

  > .MuiListItem-root {
    justify-content: 'space-between';
    &:hover {
      background: none;
    }
  }
`;
